// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aVfJ4{display:flex;flex-direction:column;padding:8px 0}.O59cl{flex:1;min-width:0}.LK_yO{flex:1;min-width:0}._gl8_{max-width:100%}.XeV3U{font-size:12px;line-height:16px}.P4E1x{flex-shrink:0;display:inline-flex}.xwM2z{flex-shrink:0}.FQHd5{opacity:.45}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `aVfJ4`,
	"rowBody": `O59cl`,
	"rowText": `LK_yO`,
	"rowName": `_gl8_`,
	"rowSub": `XeV3U`,
	"noShrink": `P4E1x`,
	"hideToggle": `xwM2z`,
	"dimmed": `FQHd5`
};
export default ___CSS_LOADER_EXPORT___;
